module.exports = __webpack_public_path__ + "static/6305-woodrose-20-7cec4882a9c44c816ff3f72b12e5c0a5.jpg";